<template>
    <NuxtLayout name="malt-base-layout">
        <slot />
        <template #admin-tools>
            <slot name="admin-tools" />
        </template>
    </NuxtLayout>
</template>
